import { ToolBase } from ".";
import { fabric } from "../fabric";

export class EraserTool extends ToolBase {

  /**
   * @inheritdoc
   */
  constructor(imageEditor, name, opts) {
    super(imageEditor, name, opts);

    let styleModule = this.imageEditor.getModule("style");
    
    styleModule.on("change", (data) => {
      this.imageEditor.canvas.freeDrawingBrush.width = data.strokeSize;
    })

  }

  setActive(value) {
    let styleModule = this.imageEditor.getModule("style");
    super.setActive(value);
    this.imageEditor.canvas.isDrawingMode = value;

    if(value){
      this.imageEditor.canvas.freeDrawingBrush = new fabric.EraserBrush(this.imageEditor.canvas);
      this.imageEditor.canvas.freeDrawingBrush.width = styleModule.strokeSize;
    }
  }

}